import React from 'react';
import { connect } from 'react-redux';
import { updateOrCreateAlertConfig } from '../../../store/api/calls';
import BaseModal from './BaseModal';
import Input from '../forms/Input';
import { startCase } from 'lodash';

class AlertConfigCreateEditModal extends React.Component {
  constructor(props) {
    super(props);

    let ei = this.props.editingInstance || {};

    this.defaultState = {
      trigger: ei.trigger,
      event_types: ei.event_types || [],
      operator: ei.operator || null,
      value_threshold: ei.value_threshold || null,
      time_threshold: ei.time_threshold || null,
      script_element: ei.script_element || null,
    };

    this.state = {
      ...this.defaultState,
    };

    this.eventTriggerDependencies = {
      distance_from_target: {
        defaultEvents: ['log_response'],
        allowedEvents: ['log_response', 'door_canvass', 'check_in', 'check_out'],
        valueThresholdType: 'number',
        valueThresholdTitle: 'Threshold Distance In Meters',
        valueThresholdAllowedOperators: ['>', '<'],
        timeThreshold: false,
      },
      event_is: {
        defaultEvents: ['log_response'],
        allowedEvents: [
          'log_response',
          'door_canvass',
          'check_in',
          'check_out',
          'log_in',
          'log_out',
          'create_site',
        ],
        valueThresholdType: null,
        valueThresholdTitle: '',
        valueThresholdAllowedOperators: [],
        timeThreshold: false,
      },
      event_count: {
        defaultEvents: ['log_response'],
        allowedEvents: [
          'log_response',
          'door_canvass',
          'check_in',
          'check_out',
          'log_in',
          'log_out',
          'create_site',
        ],
        valueThresholdType: 'number',
        valueThresholdTitle: 'Count Threshold',
        valueThresholdAllowedOperators: ['>', '<'],
        timeThreshold: true,
      },
      response_is: {
        defaultEvents: ['log_response'],
        allowedEvents: ['log_response'],
        valueThresholdType: 'string',
        valueThresholdTitle: 'Response to Match (case insensitive)',
        valueThresholdAllowedOperators: ['contains', 'starts_with', 'is_exactly', 'exists'],
        timeThreshold: false,
      },
    };
  }

  _handleEventTypeChange = (eventType) => {
    if (!eventType) return;

    const alreadyIncluded = this.state.event_types.includes(eventType);

    if (alreadyIncluded) {
      this.setState({ event_types: this.state.event_types.filter((d) => d !== eventType) });
    } else {
      this.setState({ event_types: [...this.state.event_types, eventType] });
    }
  };

  _isComplete = () => {
    if (!this.state.trigger || !this.state.event_types.length) return false;

    let deps = this.eventTriggerDependencies[this.state.trigger];

    if (deps.valueThresholdType) {
      if (!this.state.operator) return false;
      if (
        !this.state.value_threshold &&
        !['exists', 'does_not_exist'].includes(this.state.operator)
      )
        return false;
    }

    if (this.state.trigger === 'response_is') {
      if (!this.state.script_element) return false;
    }

    if (deps.timeThreshold) {
      if (!this.state.time_threshold) return false;
    }

    return true;
  };

  _handleFormSubmission = () => {
    let script_element = this.state.script_element
      ? this.props.script.elements.find((d) => d.id === this.state.script_element)
      : {};
    let script_element_name = `${script_element.name} [${script_element.type}]`;

    //NEED TO ADD BACK IN EDITING INSTANCE FOR CASES WHERE THIS DOESN'T WORK.
    let data = {
      id: this.props.editingInstance ? this.props.editingInstance.id : null,
      sitecanvass: this.props.siteCanvass.id,
      doorcanvass: this.props.doorCanvass.id,
      config: {
        trigger: this.state.trigger,
        event_types: this.state.event_types,
        operator: this.state.operator,
        value_threshold: this.state.value_threshold,
        time_threshold: this.state.time_threshold,
        script_element: this.state.script_element,
        script_element_name,
      },
    };

    return updateOrCreateAlertConfig(data).then((alert) => {
      this.props.onCompleteSubmission && this.props.onCompleteSubmission(alert);
    });
  };

  _generateScriptElementSelector = () => {
    let { script } = this.props;

    let options = script.elements
      .filter((d) => !['start', 'speech'].includes(d.type))
      .map((d) => {
        return {
          display: `${d.name} [${d.type}]`,
          value: d.id,
        };
      });

    return (
      <>
        <Input
          type={'select'}
          value={this.state.script_element}
          title={'Script Element'}
          onChange={(val) => {
            this.setState({
              script_element: +val,
            });
          }}
          options={[
            { value: null, display: '- -', disabled: this.state.script_element },
            ...options,
          ]}
        />
      </>
    );
  };

  _buildForm = () => {
    return (
      <div>
        {/*<h5 className={'primary-text'}>Trigger</h5>*/}
        <div className={'flx'}>
          <Input
            type={'select'}
            value={this.state.trigger}
            title={'Trigger'}
            onChange={(val) => {
              if (!val) return;
              this.setState({
                ...this.defaultState,
                trigger: val,
                event_types: this.eventTriggerDependencies[val].defaultEvents,
              });
            }}
            options={[
              { value: null, display: '- -', disabled: this.state.trigger },
              { value: 'distance_from_target', display: 'Distance from Target' },
              { value: 'event_count', display: 'Event Count in Time Period' },
              { value: 'event_is', display: 'Event is' },
              { value: 'response_is', display: 'Response Is' },
              // {value: 'door_status_is', display: "Door Status Is"},
              // {value: 'door_status_count', display: "Door Status Count in Time Period"},
            ]}
          />
        </div>

        {!!this.state.trigger && (
          <>
            <h6 className={'mb-1'}>
              <b>Event Types to Consider</b>
            </h6>
            <div className={'flx is-flex-wrap-wrap mb-3'}>
              {this.eventTriggerDependencies[this.state.trigger].allowedEvents.map((eventType) => (
                <Input
                  classNames={'mx-3 my-0'}
                  type={'checkbox'}
                  title={startCase(eventType)}
                  value={this.state.event_types.includes(eventType)}
                  onChange={() => this._handleEventTypeChange(eventType)}
                  defaultChecked={this.state.event_types.includes(eventType)}
                />
              ))}
            </div>

            {this.state.trigger === 'response_is' && (
              <div className={'flx'}>{this._generateScriptElementSelector()}</div>
            )}

            {this.eventTriggerDependencies[this.state.trigger].valueThresholdType && (
              <div className={'flx'}>
                <Input
                  type={'select'}
                  title={'Operator'}
                  onChange={(val) =>
                    this.setState({
                      operator: val,
                    })
                  }
                  options={[
                    { value: null, display: '- -' },
                    ...this.eventTriggerDependencies[
                      this.state.trigger
                    ].valueThresholdAllowedOperators.map((d) => ({ value: d, display: d })),
                  ]}
                  value={this.state.operator}
                />
                {!['exists', 'does_not_exist'].includes(this.state.operator) && (
                  <Input
                    type={'text'}
                    classNames={'mx-5'}
                    title={this.eventTriggerDependencies[this.state.trigger].valueThresholdTitle}
                    onChange={(val) =>
                      this.setState({
                        value_threshold: val,
                      })
                    }
                    value={this.state.value_threshold}
                  />
                )}

                {this.eventTriggerDependencies[this.state.trigger].timeThreshold && (
                  <Input
                    type={'text'}
                    title={'Time Period (min)'}
                    onChange={(val) =>
                      this.setState({
                        time_threshold: val,
                      })
                    }
                    value={this.state.time_threshold}
                  />
                )}
              </div>
            )}
          </>
        )}

        <div className={'button-wrapper'}>
          <div
            className={`button ${this._isComplete() ? '' : 'disabled'}`}
            onClick={this._handleFormSubmission}
          >
            Submit
          </div>
          <div className={'button secondary-milligram'} onClick={this.props.onClose}>
            Cancel
          </div>
        </div>
      </div>
    );

    /*
         *
         *              <Input type={'checkbox'} value={this.state.showAssignedCanvassers}
                   defaultChecked={this.state.showAssignedCanvassers}
                   onChange={() => this.setState({showAssignedCanvassers: !this.state.showAssignedCanvassers})}
                   title={'Show Assigned'}
                   style={{marginBottom: '1px'}}
            />*/
  };

  render() {
    return (
      <BaseModal
        title={`${!!this.props.editingInstance ? 'Edit an' : 'Create a new'} alert`}
        center
        {...this.props}
      >
        <div className={'px-6'}>{this._buildForm()}</div>
      </BaseModal>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(AlertConfigCreateEditModal);
